import { Epic } from 'redux-observable';
import { from } from 'rxjs';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import { DashboardViewServiceImpl } from '../services';
import {
  dashboardViewFetchDashboardFailed,
  dashboardViewFetchDashboardRequest,
  dashboardViewFetchDashboardSuccess,
} from '../dashboardViewSlice';
import { RootState } from '../../../../store';

type IN = ReturnType<typeof dashboardViewFetchDashboardRequest>;
type OUT =
  | ReturnType<typeof dashboardViewFetchDashboardSuccess>
  | ReturnType<typeof dashboardViewFetchDashboardFailed>;

export const DashboardViewOnFetchDataEpic: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(dashboardViewFetchDashboardRequest.match),
    withLatestFrom(state$),
    switchMap(([, state]) => {
      return from(
        DashboardViewServiceImpl.getDashboardData()
          .then((data) => dashboardViewFetchDashboardSuccess(data))
          .catch((error) => {
            console.error(error);
            return dashboardViewFetchDashboardFailed({
              msg: 'Failed to fetch data',
            });
          }),
      );
    }),
  );
